if (!customElements.get("bundle-breakdown-product-grid")) {
  class BundleBreakdownProductGrid extends HTMLElement {
    constructor() {
      super();
    }

    // Called when the element is added to the document
    connectedCallback() {
      this.bundleBreakdownPopup = this.querySelector(
        ".bundle-breakdown--popup"
      );

      this.addEventListener("click", this.sectionEventHandler.bind(this));

      document.addEventListener("keydown", (event) => {
        if (event.key === "Escape") {
          this.toggleMainPopup(false);
          this.closeOpenedPopup();
        }
      });
    }

    // Called when the element is removed from the document
    disconnectedCallback() {
      this.removeEventListener("click", this.sectionEventHandler.bind(this));
    }

    // Event handler for click events within the custom element
    sectionEventHandler(event) {
      const productGridItemCta = event.target.closest(
        ".product-grid-item--cta"
      );

      if (productGridItemCta) {
        this.productGridCtaEventHandler(productGridItemCta);
        return;
      }

      this.toggleMainPopup(false);
      this.closeOpenedPopup();
    }

    // Event handler for product grid item CTA clicks
    productGridCtaEventHandler(button) {
      const { productGridItemHandle } = button.dataset;
      const content = this.querySelector(
        `.bundle-breakdown--popup-content[data-popup-handle="${productGridItemHandle}"]`
      );
      content.dataset.openPopup = true;
      this.toggleMainPopup(true);
    }

    // Function to toggle the visibility of the main popup
    toggleMainPopup(flag) {
      this.bundleBreakdownPopup.dataset.openBundleBreakdownPopup = flag;
      this.bundleBreakdownPopup.ariaExpanded = flag;
      document.body.style.overflow = flag ? "hidden" : "visible";
    }

    // Function to close any opened popup content
    closeOpenedPopup() {
      this.bundleBreakdownPopup.querySelector(
        `.bundle-breakdown--popup-content[data-open-popup="true"]`
      ).dataset.openPopup = false;
    }
  }

  customElements.define(
    "bundle-breakdown-product-grid",
    BundleBreakdownProductGrid
  );
}
